import { FORMAT_DATE_YYYY_MM_DD, MONTH_DAYS } from 'constants/app.constant'
import dayjs from 'dayjs'

/**
 * function obtain range date for subscription
 * @param {string} date
 * @returns {{start: string, end: string}}
 */
export const calculateRangeDate = (date) => {
    date = cleanDate(date)
    const endDate = addMonthByDate(date)
    const start = dayjs(date).format(FORMAT_DATE_YYYY_MM_DD)
    const end = dayjs(endDate).format(FORMAT_DATE_YYYY_MM_DD)
    return { start, end }
}

export const cleanDate = (date) => {
    if (!date) return
    if (date.includes('Z')) return date.replace('Z', '')
    return date
}

export const addMonthByDate = (date) => {
    if (!date) return
    const parseDate = new Date(cleanDate(date))
    parseDate.setDate(parseDate.getDate() + MONTH_DAYS)
    return parseDate
}

export const isFinishSubscription = (date) => {
    const endDate = addMonthByDate(date)
    const currentDate = new Date()

    // clean hours for compare only days
    endDate.setHours(0, 0, 0, 0)
    currentDate.setHours(0, 0, 0, 0)

    const diff = endDate - currentDate
    const dayDiff = Math.round(diff / 86400000)

    if (dayDiff >= 0) return false
    return true
}

export const formatHours = (hours) => {
    if (!hours) return

    const [hour, min] = hours.split(':').map(Number)
    const AMorPM = hour >= 12 ? 'PM' : 'AM'

    let formatHour = hour % 12
    formatHour = formatHour === 0 ? 12 : formatHour

    return `${formatHour}:${min.toString().padStart(2, '0')} ${AMorPM}`
}

export const isEqualDate = (date1, date2) => {
    const d1 = new Date(date1).setHours(0, 0, 0, 0)
    const d2 = new Date(date2).setHours(0, 0, 0, 0)
    return d1 === d2
}
